import * as CL from '@design-system/component-library';
import { dsClass } from '../../common/constants/dsClasses';
import { t } from '../../common/i18n';

export const InvitationWillBeSentDisclaimer = () => (
  <CL.Disclaimer
    title={t.YX9H('The user will be sent an invitation email')}
    text={t.T6BJ(
      'The user will receive an invitation link through email. The user must accept the invitation within 14 days.'
    )}
    disclaimerType="info"
    icon={<CL.Icon icon="information" type="regular" aria-hidden="true" />}
    className={dsClass.MARGIN_VERTICAL_6}
    visible
  />
);
